Ext.define('SA.view.DomListenerBuilder', {
    statics: {
        keydown(key) {
            return new SA.view.DomListenerBuilder().eventName('keydown').key(key);
        },

        mousemove() {
            return new SA.view.DomListenerBuilder().eventName('mousemove');
        }
    },

    constructor() {
        this.params = {};
    },

    cb(cb) {
        var {eventName, key} = this.params,
            resolvedCb = Ext.isString(key) ? keyScopedCb : cb,
            listen = () => document.body.addEventListener(eventName, resolvedCb),
            unlisten = () => document.body.removeEventListener(eventName, resolvedCb);

        return {listen, unlisten};

        function keyScopedCb(ev) {
            if (ev.code !== key) {
                return;
            }

            cb();
        }
    },

    eventName(eventName) {
        this.params.eventName = eventName;
        return this;
    },

    key(key) {
        this.params.key = key;
        return this;
    }
});